/**
 * 自由职业者结算统计
 */
<template>
  <div class="data-center-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>自由职业者结算统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="user-search" label-width="100px">
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="商户 :">
            <el-input
              size="small"
              v-model="formInline.merchantName"
              placeholder="请输入商户"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="服务商 :">
            <el-input
              size="small"
              v-model="formInline.disCompanyName"
              placeholder="请输入服务商"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="姓名 :">
            <el-input
              size="small"
              v-model="formInline.payeeName"
              placeholder="请输入自由职业者姓名"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="证件号 :">
            <el-input
              size="small"
              v-model="formInline.identityDocumentNumber"
              placeholder="请输入自由职业者证件号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="交易时间 : ">
            <el-date-picker
              size="small"
              v-model="formInline.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label-width="30px">
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="reset()">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="table-toolbar">
      <el-button size="small" type="primary" @click="exportData"
        >导出数据</el-button
      >
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      empty-text="暂无数据"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column
        fixed
        prop="merchantName"
        label="商户"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.merchantName)">
            {{ scope.row.merchantName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="disCompanyName"
        label="服务商"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.disCompanyName)">
            {{ scope.row.disCompanyName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="payeeName" label="姓名" show-overflow-tooltip>
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.payeeName)">
            {{ scope.row.payeeName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="证件信息" show-overflow-tooltip min-width="120">
        <template slot-scope="scope">
          <span @dblclick="copyToClipboard(scope.row.identityDocumentNumber)">
            {{ scope.row.identityDocumentTypeStr }}:
            {{ scope.row.identityDocumentNumber }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="totalServiceFee"
        label="总服务费（元）"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.totalServiceFee.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="totalNumberTransactions"
        label="总笔数"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="totalManagementFee"
        label="总管理费（元）"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.totalManagementFee.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="amountReceived"
        label="实际到账（元）"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.amountReceived.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="individualIncomeTax"
        label="个税（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.individualIncomeTax.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="valueAddedTax"
        label="增值税（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.valueAddedTax.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="additionalTax"
        label="附加税（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.additionalTax.toFixed(2) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="summary-bar"
      v-if="listData && listData.length"
    >
      <div class="summary-item">
        <span class="summary-label">总笔数</span>
        <span class="summary-value">{{
          currentPageSummary.totalNumberTransactions
        }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">总管理费</span>
        <span class="summary-value">{{
          formatNumber(currentPageSummary.totalManagementFee)
        }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">总服务费</span>
        <span class="summary-value">{{
          formatNumber(currentPageSummary.totalServiceFee)
        }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">实际到账</span>
        <span class="summary-value is-amount">{{
          formatNumber(currentPageSummary.amountReceived)
        }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">个税</span>
        <span class="summary-value">{{
          formatNumber(currentPageSummary.individualIncomeTax)
        }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">增值税</span>
        <span class="summary-value">{{
          formatNumber(currentPageSummary.valueAddedTax)
        }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">附加税</span>
        <span class="summary-value">{{
          formatNumber(currentPageSummary.additionalTax)
        }}</span>
      </div>
    </div>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="部门名称" prop="deptName">
          <el-input
            size="small"
            v-model="editForm.deptName"
            auto-complete="off"
            placeholder="请输入部门名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input
            size="small"
            v-model="editForm.deptNo"
            auto-complete="off"
            placeholder="请输入部门代码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  freelanceStatistics,
  exportfreelancerstatistics,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        date: [],
        positionId: "",
        positionName: "",
        positionState: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: "",
        identityDocumentNumber: "",
        date: [],
        distributeChannelName: "",
        payeeName: "",
        batchNumber: "",
        disCompanyName: "",
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  computed: {
    currentPageSummary() {
      return this.listData.reduce(
        (acc, item) => {
          acc.totalNumberTransactions +=
            Number(item.totalNumberTransactions) || 0;
          acc.totalManagementFee += Number(item.totalManagementFee) || 0;
          acc.totalServiceFee += Number(item.totalServiceFee) || 0;
          acc.amountReceived += Number(item.amountReceived) || 0;
          acc.individualIncomeTax += Number(item.individualIncomeTax) || 0;
          acc.valueAddedTax += Number(item.valueAddedTax) || 0;
          acc.additionalTax += Number(item.additionalTax) || 0;
          return acc;
        },
        {
          totalNumberTransactions: 0,
          totalManagementFee: 0,
          totalServiceFee: 0,
          amountReceived: 0,
          individualIncomeTax: 0,
          valueAddedTax: 0,
          additionalTax: 0,
        }
      );
    },
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        merchantName: "",
        identityDocumentNumber: "",
        date: [],
        distributeChannelName: "",
        payeeName: "",
        batchNumber: "",
        disCompanyName: "",
      };
      this.getdata();
    },
    detail_list() {},
    //导出数据
    exportData() {
      let params = {
        page: 1,
        pageSize: 999999999,
        merchantName: this.formInline.merchantName,
        identityDocumentNumber: this.formInline.identityDocumentNumber,
        distributeChannelName: this.formInline.distributeChannelName,
        payeeName: this.formInline.payeeName,
        batchNumber: this.formInline.batchNumber,
        disCompanyName: this.formInline.disCompanyName,
        startDate: (this.formInline.date && this.formInline.date[0]) || "",
        endDate: (this.formInline.date && this.formInline.date[1]) || "",
      };

      exportfreelancerstatistics(params).then((res) => {
        if (res.msg == "success") {
          window.open(res.data.downloadUrl);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 获取公司列表
    getdata() {
      let params = {
        page: this.formInline.page,
        pageSize: this.formInline.pageSize,
        merchantName: this.formInline.merchantName,
        identityDocumentNumber: this.formInline.identityDocumentNumber,
        distributeChannelName: this.formInline.distributeChannelName,
        payeeName: this.formInline.payeeName,
        batchNumber: this.formInline.batchNumber,
        disCompanyName: this.formInline.disCompanyName,
        startDate: (this.formInline.date && this.formInline.date[0]) || "",
        endDate: (this.formInline.date && this.formInline.date[1]) || "",
      };
      freelanceStatistics(params)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
          // this.$message.error('菜单加载失败，请稍后再试！')
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.deptId = row.deptId;
        this.editForm.deptName = row.deptName;
        this.editForm.deptNo = row.deptNo;
      } else {
        this.title = "添加";
        this.editForm.deptId = "";
        this.editForm.deptName = "";
        this.editForm.deptNo = "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          // deptSave(this.editForm)
          //   .then(res => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     if (res.success) {
          //       this.getdata(this.formInline)
          //       this.$message({
          //         type: 'success',
          //         message: '公司保存成功！'
          //       })
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     this.$message.error('公司保存失败，请稍后再试！')
          //   })
        } else {
          return false;
        }
      });
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
    formatNumber(num) {
      return num ? num.toFixed(2) : "0.00";
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message({
              message: "已复制到剪贴板",
              type: "success",
            });
          },
          () => {
            this.$message.error("复制失败，请重试！");
          }
        );
      } else {
        // 兼容旧浏览器
        const input = document.createElement("textarea");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "已复制到剪贴板",
            type: "success",
          });
        } catch (err) {
          this.$message.error("复制失败，请重试！");
        }
        document.body.removeChild(input);
      }
    },
  },
};
</script>

<style scoped>
.data-center-page {
  padding-bottom: 8px;
}
.user-search {
  margin-top: 16px;
  margin-bottom: 12px;
  padding: 16px 16px 6px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.table-toolbar {
  margin-bottom: 12px;
}
.summary-bar {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px 32px;
  margin-top: 12px;
  padding: 16px 24px;
  background: #fff;
}
.summary-item {
  display: flex;
  align-items: center;
  min-width: 0;
  font-size: 13px;
  line-height: 1.5;
}
.summary-label {
  flex-shrink: 0;
  width: 72px;
  color: #909399;
}
.summary-value {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #303133;
}
.summary-value.is-amount {
  color: #067d62;
}
</style>

 


// WEBPACK FOOTER //
// src/views/dataCenter/ReceivableTransactionStatistics.vue